import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

interface TeamMember {
    name: string;
    role: string;
    team: string;
    icon: string;
    defaultColor: string;
    shape: 'default' | 'round';
    card: string | null;
    badge: number | null;
}

@Component({
    selector: 'demo-upp-thumb',
    templateUrl: './demo-upp-thumb.html',
    styleUrls: ['../demo-common.scss', './demo-upp-thumb.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppThumbComponent {
    colorOverride: string | null = null;
    colors = ['primary', 'success', 'warning', 'danger'];

    members: TeamMember[] = [
        { name: 'Alice', role: 'Developer', team: '', icon: 'person-outline', defaultColor: 'primary', shape: 'default', card: null, badge: null },
        { name: 'Bob', role: 'Designer', team: '', icon: 'color-palette-outline', defaultColor: 'success', shape: 'default', card: null, badge: null },
        { name: 'Carol', role: 'QA Lead', team: '', icon: 'person-outline', defaultColor: 'tertiary', shape: 'round', card: null, badge: null },
        { name: 'Dave', role: 'Team Lead', team: 'Engineering', icon: 'briefcase-outline', defaultColor: 'warning', shape: 'default', card: 'card', badge: null },
    ];

    constructor(private change: ChangeDetectorRef) {}

    getColor(member: TeamMember): string {
        return this.colorOverride || member.defaultColor;
    }

    setColorOverride(color: string | null) {
        this.colorOverride = color;
        this.change.markForCheck();
    }

    onThumbSelect(name: string) {
        console.log('Selected:', name);
    }
}
